import { CommonFunctions } from '../static/common-functions';
//import { Console } from '@angular/core/src/console';
import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
import { CommonValues } from '../static/CommonValues';
import { RelatedJobBus } from './RelatedJobBus';
import { ConstructionChartDetail } from './ConstructionChartDetail';
import { InvoiceDrawBus } from './InvoiceDrawBus';
import { DispatchNoteBus } from './DispatchNoteBus';

export class CnstCostDetailOrdersBus extends BaseBus {
    CID(): any {
        return null;
    }
    constructor(data: CnstCostDetailOrdersBus) {
        super(data);

        if (CommonFunctions.hasValue(data)) {
            this.dateEntered = CommonFunctions.getDate(data.dateEntered);
            this.datePosted = CommonFunctions.getDate(data.datePosted);
        }

    }

    initialize(data: CnstCostDetailOrdersBus) {
    super.initialize(data);

    }

    orderId: string
    jobNumber: string
    orderNumber: string
    dateEntered: Date
    supplierName: string;
    blanketAmount: number;
    chgOrdBlanketAmount: number;
    newBlanketAmount: number;
    orderStatusName: string;
    buyerLegalName: string;
    totalPosted: number;
    balanceRemaining: number;
    datePosted: Date
    childOrders: CnstCostDetailOrdersBus[]

}
